import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  getSinglie: async (id: string) => {
    return request(`${API_URL}/margins/${id}`, 'get');
  },

  getAll: async () => {
    return request(`${API_URL}/margins/get-all`, 'post');
  },

  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/margins/create`, 'post', body);
  },

  update: async (id: string, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/margins/update/${id}`, 'put', body);
  },

  delete: async (id: string) => {
    return request(`${API_URL}/margins/delete/${id}`, 'delete');
  },
};